// extracted by mini-css-extract-plugin
export var footerContainer = "Footer-module--footerContainer--Y00s9";
export var mainContent = "Footer-module--mainContent--u9402";
export var linkSection = "Footer-module--linkSection--ow+F5";
export var categoryWrapper = "Footer-module--categoryWrapper---oM9r";
export var infoSection = "Footer-module--infoSection--HWwtV";
export var description = "Footer-module--description--brUxG";
export var link = "Footer-module--link--ixJIY";
export var copyrightContainer = "Footer-module--copyrightContainer--Y7VhV";
export var socialMedia = "Footer-module--socialMedia--vAhGN";
export var bottomContainer = "Footer-module--bottomContainer--Mvade";